<template>
  <SingleColumn v-if="success">
    <template #header>
      <ProfileHeader :resource="resource" />
    </template>
    <template #content>
      <div class="bg-white rounded-lg shadow">
        <section v-if="resource.profile">
          <div class="px-4 py-5 sm:px-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Persönliche Angaben
            </h3>
          </div>
          <div class="border-t border-gray-200 px-4 py-5 sm:p-0">
            <DetailsList>
              <DetailsListItem :value="resource.profile.username">
                Benutzername
              </DetailsListItem>
              <DetailsListItem :value="resource.profile.position.trans">
                Position
              </DetailsListItem>
              <DetailsListItem :value="resource.profile.language.trans">
                Sprache
              </DetailsListItem>
            </DetailsList>
          </div>
        </section>
        <section v-else="resource.profile">
          <div class="px-4 py-5 sm:px-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Persönliche Angaben
            </h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              Der Benutzer hat keine Profilangaben hinterlegt.
            </p>
          </div>
        </section>
      </div>
    </template>
  </SingleColumn>
  <SingleColumn v-else>
    <template #header>
      <section class="sm:flex sm:items-center sm:justify-between">
        <div class="sm:flex sm:space-x-5">
          <h1 class="text-3xl font-bold text-white">
            Hier hat etwas nicht geklappt...
          </h1>
        </div>
      </section>
    </template>
    <template #content>
      <GenericError />
    </template>
  </SingleColumn>
</template>

<script setup>
import { onMounted, computed, watch } from 'vue';
import { useRetrieveResource } from '@/client/actions';

const props = defineProps({id: String});
const target = computed(() => '/api/users/' + props.id);
const action = useRetrieveResource(target);

const { resource, retrieving, retrieve, success } = action;

const mounted = onMounted(() => retrieve());
const watcher = watch(target, (v) => retrieve());
</script>
